module.exports = __webpack_public_path__ + "static/media/icono (2).26209ce8.svg";